import { ITransaction } from 'ui-toolkit/orders/interfaces/ITransaction';
import { eTransactionCategory } from 'ui-toolkit/enums/eTransactionType';
import { IClientOrderData } from 'types/clientPortal/IClientOrderData';

export const newGetTransaction = (data?: IClientOrderData): ITransaction => {
  let purchasePrice =
    data?.transactionCategory === eTransactionCategory.Purchase ? data?.estimatedPropertyValueCents || 0 : null;

  return {
    id: data?.id || null,
    file_number: data?.fileNumber ? data.fileNumber + '' : '',
    closing_date: data?.closesOn || null,
    estimated_closing_date: data?.estimatedClosesOn || null,
    rate_lock_expiration: data?.rateLockExpiration || null,
    external_party_transaction_id: data?.externalPartyTransactionId || null,

    purchase_price: purchasePrice,
    estimated_property_value: data?.estimatedPropertyValueCents || 0,

    loan_amount: data?.loanAmount || null,

    loan_number: data?.loanId || null,

    loan_type: data?.loanType || null,
    occupancy_type: data?.occupancyType || null,

    owner_name: data?.ownerName || null,

    property_type: data?.propertyType || null,
    solar_panels: data?.solarPanels || null,
    transaction_category: data?.transactionCategory || eTransactionCategory.Refinance,
    order_group_category: null,
    order_group_id: null,
    relocation_employer_name: data?.relocationEmployerName || null,
  };
};
